module.exports = __webpack_public_path__ + "static/media/4.6d173255.jpg";